export default "__VITE_ASSET__89c891b5__"